/** Intervallo di date in millisecondi. */
export interface DateRange {
  startDate: number;
  endDate: number;
}

/**
 * Ultima settimana fino a ieri (`Utils.getStartingDate`). Il primo del mese la
 * fine cade sul giorno 30/31 del mese corrente: e' il comportamento legacy.
 */
export function lastWeekRange(now: Date = new Date()): DateRange {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const lastWeek = new Date(now);
  lastWeek.setDate(today.getDate() - 7);
  lastWeek.setHours(0, 0, 0, 0);
  const yesterday = new Date(now);
  yesterday.setDate(today.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);
  const midnight = new Date(now);
  midnight.setDate(yesterday.getDate());
  midnight.setHours(23, 59, 59, 0);
  return { startDate: lastWeek.getTime(), endDate: midnight.getTime() };
}

/** Solo ieri (getter `date` della Dashboard legacy, stesso quirk del primo del mese). */
export function yesterdayRange(now: Date = new Date()): DateRange {
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);
  const midnight = new Date(now);
  midnight.setDate(yesterday.getDate());
  midnight.setHours(23, 59, 59, 0);
  return { startDate: yesterday.getTime(), endDate: midnight.getTime() };
}

/** Query string con i timestamp in secondi. */
export function timestampQuery(range: DateRange): string {
  return `fromTimestamp=${range.startDate / 1000}&toTimestamp=${range.endDate / 1000}`;
}
